export enum ActionTypes {
  FORM_SUBMIT = 'formSubmit',
  REDIRECT = 'redirect',
  RENDER_CONTENT = 'renderContent',
}
